export default __webpack_public_path__ + "static/media/bm-5.ea319e52.png";